/* eslint-disable */
import {
    GETGROUP_NAMES_FOR_COMBO, GETPOST_NAMES_FOR_COMBO, SEARCH_ADVERTISEMENT_REPORTS, FILTER_ADVERTISEMENT_REPORTS, GETDEPARTMENT_NAMES_FOR_COMBO, GETEXAM_TYPES_FOR_COMBO, GETRECRUITMENT_TYPES_FOR_COMBO, GET_ALL_DEPARTMENTWISE_SUMMARY, FILTER_DEPARTMENTWISE_SUMMARY, GET_REPORT_DATA_LIST, GET_ADVERTISEMENT_NO_REPORT_DATA, FILTER_REPORT_DATA, GET_GROUP_NAMES_FOR_COMBO, GET_EXAM_TYPES_FOR_COMBO, GET_DEPARTMENT_NAMES_FOR_COMBO, GET_DATE_RANGE,
    GET_ALL_ADVERTISEMENT_REPORT_LIST, GET_ALL_FILTER_ADVERTISEMENT_REPORT_LIST, GET_ALL_DEPARTMENTWISE_SUMMARY_LIST, GET_ALL_FILTER_DEPARTMENTWISE_SUMMARY_LIST, GET_ALL_REPORT_DATA_LIST, GET_ALL_FILTER_REPORT_DATA
} from "../../common/constants/endpoints";
import API from "../../helpers/API";
import {
    SET_DEPARTMENT_NAMES_COMBO, SET_EXAM_TYPES_COMBO, SET_GROUP_NAMES_COMBO, SET_POST_NAMES_COMBO, SET_ALL_ADVERTISEMENTREPORT, SET_ALL_ADVERTISEMENTREPORT_PAGE_NO_COUNTER, SET_RECRUITMENT_TYPES_COMBO, SET_ALL_DEPARTMENTWISESUMMARY, SET_ALL_DEPARTMENTWISESUMMARY_PAGE_NO_COUNTER, SET_GET_ALL_REPORT_DATA, SET_REPORT_DATA_PAGE_NO_COUNTER, SET_DEPARTMENT_COMBO, SET_EXAM_COMBO, SET_GROUP_COMBO, SET_ADV_NO, SET_DATE_DATA, SET_STATE,
    SET_All_REQUISITION_REPORT_DATA, SET_All_DEPARTMENTWISE_REPORT_DATA, SET_All_ADVERTISEMENT_REPORT_DATA
} from '../../common/constants/ActionTypes';
import { toastr } from 'react-redux-toastr';

export const getAllDepartmentCombo = () => {
    return async (dispatch) => {
        try {
            let response = await API.get(GETDEPARTMENT_NAMES_FOR_COMBO);
            if (response && response.data) {
                dispatch({
                    payload: response.data,
                    type: SET_DEPARTMENT_NAMES_COMBO
                });
                dispatch({
                    type: SET_DEPARTMENT_COMBO,
                    payload: response.data

                });
            }

        } catch (error) {
            let errorMessage = ""
            if (error.response && error.response.data) {
                errorMessage = error.response.data.message;
            } else {
                errorMessage = error.message;
            }
            toastr.error("Error While Fetching the Department Names:", errorMessage);
        }
    }
};

export const getAllExamTypeCombo = () => {
    return async (dispatch) => {
        try {
            // eslint-disable-next-line no-useless-concat
            let response = await API.get(GETEXAM_TYPES_FOR_COMBO + `?module=exam_creation` + `&type=exam_type`);
            if (response && response.data) {
                dispatch({
                    payload: response.data,
                    type: SET_EXAM_TYPES_COMBO
                });
                dispatch({
                    payload: response.data,
                    type: SET_EXAM_COMBO
                });
                dispatch({
                    payload: response.data,
                    type: SET_RECRUITMENT_TYPES_COMBO
                });
            }

        } catch (error) {
            let errorMessage = ""
            if (error.response && error.response.data) {
                errorMessage = error.response.data.message;
            } else {
                errorMessage = error.message;
            }
            toastr.error("Error While Fetching the Exam Types:", errorMessage);
        }
    }
}

export const getAllPostCombo = () => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GETPOST_NAMES_FOR_COMBO, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_POST_NAMES_COMBO,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
}

export const getAllGroupCombo = () => {
    return async (dispatch) => {
        try {
            // eslint-disable-next-line no-useless-concat
            let response = await API.get(GETGROUP_NAMES_FOR_COMBO + `?module=requisition` + `&type=group`);
            if (response && response.data) {
                dispatch({
                    payload: response.data,
                    type: SET_GROUP_NAMES_COMBO
                });
                dispatch({
                    payload: response.data,
                    type: SET_GROUP_COMBO
                });
            }

        } catch (error) {
            let errorMessage = ""
            if (error.response && error.response.data) {
                errorMessage = error.response.data.message;
            } else {
                errorMessage = error.message;
            }
            toastr.error("Error While Fetching the Group Names:", errorMessage);
        }
    }
};

export const getAllRecruitmentTypesCombo = () => {
    return async (dispatch) => {
        try {
            // eslint-disable-next-line no-useless-concat
            let response = await API.get(GETRECRUITMENT_TYPES_FOR_COMBO + `?module=exam_creation` + `&type=exam_type`);
            if (response && response.data) {
                dispatch({
                    payload: response.data,
                    type: SET_RECRUITMENT_TYPES_COMBO
                });
            }

        } catch (error) {
            let errorMessage = ""
            if (error.response && error.response.data) {
                errorMessage = error.response.data.message;
            } else {
                errorMessage = error.message;
            }
            toastr.error("Error While Fetching the Recruitment Types:", errorMessage);
        }
    }
}


export const getAllAdvertisementReportListPagination = (pageNumber, rowPerPage) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            // eslint-disable-next-line no-useless-concat
            response = await API.get(SEARCH_ADVERTISEMENT_REPORTS + `/${pageNumber}` + `/${rowPerPage}`, {
                headers: { Authorization: `Bearer ${token}` },
            });


            if (response) {
                dispatch({
                    type: SET_ALL_ADVERTISEMENTREPORT,
                    payload: response.data,
                });
                dispatch({
                    type: SET_ALL_ADVERTISEMENTREPORT_PAGE_NO_COUNTER,
                    payload: (pageNumber * rowPerPage),
                });

            }
        } catch (error) {
            dispatch({
                type: SET_ALL_ADVERTISEMENTREPORT,
                payload: {},
            });
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const getFilterAdvertisementReportListPagination = (pageNumber, rowPerPage, deptId, examType, postName, groupName, reqStartDate, reqEndDate, stageid, deskid, statusid) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {

            if ((deptId != '' && deptId != null && deptId != undefined) || (examType != '' && examType != null && examType != undefined) || (postName != '' && postName != null && postName != undefined) || (reqStartDate != '' && reqStartDate != null && reqStartDate != undefined) || (reqEndDate != '' && reqEndDate != null && reqEndDate != undefined) || (groupName != '' && groupName != null && groupName != undefined) || (stageid != '' && stageid != null && stageid != undefined) || (deskid != '' && deskid != null && deskid != undefined) || (statusid != '' && statusid != null && statusid != undefined)) {
                response = await API.get(FILTER_ADVERTISEMENT_REPORTS + `/${pageNumber}` + `/${rowPerPage}` + `?rqstartdate=${reqStartDate}` + `&rqenddate=${reqEndDate}` + `&deptid=${deptId}` + `&grpid=${groupName}` + `&typeid=${examType}` + `&postid=${postName}` + `&stageid=${stageid}` + `&deskid=${deskid}` + `&statusid=${statusid}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }
            else {
                response = await API.get(FILTER_ADVERTISEMENT_REPORTS + `/${pageNumber}` + `/${rowPerPage}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }

            if (response) {
                dispatch({
                    type: SET_ALL_ADVERTISEMENTREPORT,
                    payload: response.data,
                });
                dispatch({
                    type: SET_ALL_ADVERTISEMENTREPORT_PAGE_NO_COUNTER,
                    payload: (pageNumber * rowPerPage),
                });

            }
        } catch (error) {
            dispatch({
                type: SET_ALL_ADVERTISEMENTREPORT,
                payload: {},
            });
            dispatch({
                type: SET_All_ADVERTISEMENT_REPORT_DATA,
                payload: {}
            });
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
};

export const resetAllAdvertisementReportList = () => {
    return async function (dispatch) {
        dispatch({
            type: SET_ALL_ADVERTISEMENTREPORT,
            payload: {},
        });
    }
};

export const getDepartmentWiseReportListPagination = (pageNumber, rowPerPage) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {

            response = await API.get(GET_ALL_DEPARTMENTWISE_SUMMARY + `/${pageNumber}` + `/${rowPerPage}`, {
                headers: { Authorization: `Bearer ${token}` },
            });


            if (response) {
                dispatch({
                    type: SET_ALL_DEPARTMENTWISESUMMARY,
                    payload: response.data,
                });
                dispatch({
                    type: SET_ALL_DEPARTMENTWISESUMMARY_PAGE_NO_COUNTER,
                    payload: (pageNumber * rowPerPage),
                });

            }
        } catch (error) {
            dispatch({
                type: SET_ALL_DEPARTMENTWISESUMMARY,
                payload: {},
            });
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
};

export const getFilterDepartmentWiseReportListPagination = (pageNumber, rowPerPage, deptId, recqId, reqStartDate, reqEndDate) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            if ((deptId != '' && deptId != null && deptId != undefined) || (recqId != '' && recqId != null && recqId != undefined) || (reqStartDate != '' && reqStartDate != null && reqStartDate != undefined) || (reqEndDate != '' && reqEndDate != null && reqEndDate != undefined)) {
                response = await API.get(FILTER_DEPARTMENTWISE_SUMMARY + `/${pageNumber}` + `/${rowPerPage}` + `?rqstartdate=${reqStartDate}` + `&rqenddate=${reqEndDate}` + `&typeid=${recqId}` + `&deptid=${deptId}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }
            else {
                response = await API.get(GET_ALL_DEPARTMENTWISE_SUMMARY + `/${pageNumber}` + `/${rowPerPage}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }

            if (response) {
                dispatch({
                    type: SET_ALL_DEPARTMENTWISESUMMARY,
                    payload: response.data,
                });
                dispatch({
                    type: SET_ALL_DEPARTMENTWISESUMMARY_PAGE_NO_COUNTER,
                    payload: (pageNumber * rowPerPage),
                });

            }
        } catch (error) {
            dispatch({
                type: SET_ALL_DEPARTMENTWISESUMMARY,
                payload: {},
            });
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const resetDepartmentWiseReportList = () => {
    return async function (dispatch) {
        dispatch({
            type: SET_ALL_DEPARTMENTWISESUMMARY,
            payload: {},
        });
    }
}

export const getAllRequisitionDataReportListPagination = (pageNumber, rowPerPage) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_REPORT_DATA_LIST + `/${pageNumber}` + `/${rowPerPage}`, {
                headers: { Authorization: `Bearer ${token}` },
            });


            if (response) {
                dispatch({
                    type: SET_GET_ALL_REPORT_DATA,
                    payload: response.data,
                });
                dispatch({
                    type: SET_REPORT_DATA_PAGE_NO_COUNTER,
                    payload: (pageNumber * rowPerPage),
                });
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
}
export const resetRequisitionDataReportList = () => {
    return async (dispatch) => {
        dispatch({
            type: SET_GET_ALL_REPORT_DATA,
            payload: {}
        })
    }
}

export const getAllDepartmentReportData = () => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;

        try {
            let response = await API.get(GET_DEPARTMENT_NAMES_FOR_COMBO, {
                headers: { Authorization: `Bearer ${token}` },
            });

            if (response != null) {
                dispatch({
                    type: SET_DEPARTMENT_COMBO,
                    payload: response.data

                });
            }

        } catch (error) {
            let errorMessage = ""
            if (error.response && error.response.data) {
                errorMessage = error.response.data.message;
            } else {
                errorMessage = error.message;
            }
            toastr.error("Error While Fetching the Department:", errorMessage);
        }
    }
}

export const getAllExamTypeReportData = () => {
    return async (dispatch) => {
        try {
            let response = await API.get(GET_EXAM_TYPES_FOR_COMBO + `?module=exam_creation&type=exam_type`);
            if (response && response.data) {
                dispatch({
                    payload: response.data,
                    type: SET_EXAM_COMBO
                });
            }

        } catch (error) {
            let errorMessage = ""
            if (error.response && error.response.data) {
                errorMessage = error.response.data.message;
            } else {
                errorMessage = error.message;
            }
            toastr.error("Error While Fetching the Exam Types:", errorMessage);
        }
    }
}

export const getAllAdvertisementReportData = () => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {

            response = await API.get(GET_ADVERTISEMENT_NO_REPORT_DATA, { headers: { Authorization: `Bearer ${token}` } });
            if (response && response.data) {
                dispatch({

                    type: SET_ADV_NO,
                    payload: response.data
                });
            }

        } catch (error) {
            let errorMessage = ""
            if (error.response && error.response.data) {
                errorMessage = error.response.data.message;
            } else {
                errorMessage = error.message;
            }
            toastr.error("Error While Fetching the Advertisemant No.:", errorMessage);
        }
    }
}

export const getAllGroupReportData = () => {
    return async (dispatch) => {

        try {
            let response = await API.get(GET_GROUP_NAMES_FOR_COMBO + `?module=requisition` + `&type=group`);
            if (response && response.data) {
                dispatch({
                    payload: response.data,
                    type: SET_GROUP_COMBO
                });
            }

        } catch (error) {
            let errorMessage = ""
            if (error.response && error.response.data) {
                errorMessage = error.response.data.message;
            } else {
                errorMessage = error.message;
            }
            toastr.error("Error While Fetching the Group Names:", errorMessage);
        }
    }
}

export const getFilterReportDataListPagination = (pageNumber, rowPerPage, deptId, groupName, advNo, fromDate, toDate, examType) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(FILTER_REPORT_DATA + `/${pageNumber}` + `/${rowPerPage}` + `?deptid=${deptId}` + `&grpid=${groupName}` + `&advertisementno=${advNo}` + `&fromDate=${fromDate}` + `&toDate=${toDate}` + `&type=${examType}`, { headers: { Authorization: `Bearer ${token}` }, });
            if (response) {
                dispatch({
                    type: SET_GET_ALL_REPORT_DATA,
                    payload: response.data,
                });
                dispatch({
                    type: SET_REPORT_DATA_PAGE_NO_COUNTER,
                    payload: (pageNumber * rowPerPage),
                });
                dispatch(resetState());
            }
        } catch (error) {
            dispatch({
                type: SET_GET_ALL_REPORT_DATA,
                payload: {}
            });
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
}

export const getDateReportData = (pageNumber, rowPerPage) => {
    return async (dispatch) => {
        // const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        // let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_DATE_RANGE + `/${pageNumber}` + `/${rowPerPage}`)
            if (response && response.data) {
                dispatch({
                    payload: response.data,
                    type: SET_DATE_DATA
                });
            }
        } catch (error) {
            let errorMessage = ""
            if (error.response && error.response.data) {
                errorMessage = error.response.data.message;
            } else {
                errorMessage = error.message;
            }
            toastr.error("Error While Fetching the Requisition Data Based on Date:", errorMessage);
        }
    }
}
export const resetState = () => {
    return async function (dispatch) {
        dispatch({
            type: SET_STATE,
            payload: {},
        });
    }
}

export const getAllAdvertisementReportListData = () => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_ALL_ADVERTISEMENT_REPORT_LIST, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_All_ADVERTISEMENT_REPORT_DATA,
                payload: response.data,
            });
        } catch (error) {
            dispatch({
                type: SET_All_ADVERTISEMENT_REPORT_DATA,
                payload: {}
            });
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}
export const getAllFilterAdvertisementReportList = (deptId, examType, postName, groupName, reqStartDate, reqEndDate, stageid, deskid, statusid) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {

            if ((deptId != '' && deptId != null && deptId != undefined) || (examType != '' && examType != null && examType != undefined) || (postName != '' && postName != null && postName != undefined) || (reqStartDate != '' && reqStartDate != null && reqStartDate != undefined) || (reqEndDate != '' && reqEndDate != null && reqEndDate != undefined) || (groupName != '' && groupName != null && groupName != undefined) || (stageid != '' && stageid != null && stageid != undefined) || (deskid != '' && deskid != null && deskid != undefined) || (statusid != '' && statusid != null && statusid != undefined)) {
                response = await API.get(GET_ALL_FILTER_ADVERTISEMENT_REPORT_LIST + `?rqstartdate=${reqStartDate}` + `&rqenddate=${reqEndDate}` + `&deptid=${deptId}` + `&grpid=${groupName}` + `&typeid=${examType}` + `&postid=${postName}` + `&stageid=${stageid}` + `&deskid=${deskid}` + `&statusid=${statusid}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }
            else {
                response = await API.get(GET_ALL_ADVERTISEMENT_REPORT_LIST, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }

            if(response){
            dispatch({
                type: SET_All_ADVERTISEMENT_REPORT_DATA,
                payload: response.data,
            });
            }
        } catch (error) {
            dispatch({
                type: SET_All_ADVERTISEMENT_REPORT_DATA,
                payload: {}
            });
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}
export const getAllDepartmentWiseSummaryReportListData = () => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_ALL_DEPARTMENTWISE_SUMMARY_LIST, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_All_DEPARTMENTWISE_REPORT_DATA,
                payload: response.data,
            });
        } catch (error) {
            dispatch({
                type: SET_All_DEPARTMENTWISE_REPORT_DATA,
                payload: {}
            });
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const getAllFilterDepartmentWiseReportList = (deptId, recqId, reqStartDate, reqEndDate) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            if ((deptId != '' && deptId != null && deptId != undefined) || (recqId != '' && recqId != null && recqId != undefined) || (reqStartDate != '' && reqStartDate != null && reqStartDate != undefined) || (reqEndDate != '' && reqEndDate != null && reqEndDate != undefined)) {
                response = await API.get(GET_ALL_FILTER_DEPARTMENTWISE_SUMMARY_LIST + `?rqstartdate=${reqStartDate}` + `&rqenddate=${reqEndDate}` + `&typeid=${recqId}` + `&deptid=${deptId}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }
            else {
                response = await API.get(GET_ALL_DEPARTMENTWISE_SUMMARY_LIST, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }

            //if(response){
            dispatch({
                type: SET_All_DEPARTMENTWISE_REPORT_DATA,
                payload: response.data,
            });
            //}
        } catch (error) {
            dispatch({
                type: SET_All_DEPARTMENTWISE_REPORT_DATA,
                payload: {}
            });
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const getAllRequisitionReportDataList = () => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_ALL_REPORT_DATA_LIST, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_All_REQUISITION_REPORT_DATA,
                payload: response.data,
            });
        } catch (error) {
            dispatch({
                type: SET_All_REQUISITION_REPORT_DATA,
                payload: {}
            });
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}
export const getAllFilterRequistionReportDataList = (deptId, groupName, advNo, fromDate, toDate, examType) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            if ((deptId != '' && deptId != null && deptId != undefined) || (groupName != '' && groupName != null && groupName != undefined) || (advNo != '' && advNo != null && advNo != undefined) || (fromDate != '' && fromDate != null && fromDate != undefined) || (toDate != '' && toDate != null && toDate != undefined) || (examType != '' && examType != null && examType != undefined)) {
                response = await API.get(GET_ALL_FILTER_REPORT_DATA + `?deptid=${deptId}` + `&grpid=${groupName}` + `&advertisementno=${advNo}` + `&fromDate=${fromDate}` + `&toDate=${toDate}` + `&type=${examType}`, { headers: { Authorization: `Bearer ${token}` }, });
            }
            else {
                response = await API.get(GET_ALL_REPORT_DATA_LIST, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }
            // if(response){
            dispatch({
                type: SET_All_REQUISITION_REPORT_DATA,
                payload: response.data,
            });

            // }
        } catch (error) {
            dispatch({
                type: SET_All_REQUISITION_REPORT_DATA,
                payload: {}
            });
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
}